export const termsAndConditionsRoute = '/PrivacyPolicyWeb';

export const privacyPolicyRoute = '/PrivacyPolicyWeb'